<div class="identy_progress_dialog_box" style="width: 80%">
  <div class="identy_container">
    <div class="identy_dialog_state">
      <div class="custom-spinner pull-left"></div>
      <div class="custom-spinner-label pull-left">PLACEHOLDER</div>
    </div>
  </div>
</div>
